import { Journeys } from '@atlassian/app-provisioning';
import { LOOM_PRODUCT_ID } from '../constants';

/**
 * Adds Loom to the list of app recommendations if it is not already present.
 * The limit for apps in the discovery section is 3, so that is the max returned
 */
export function addLoomToSwitcherRecommendations(apps) {
  const hasLoom = apps.some(app => app.productId === LOOM_PRODUCT_ID);
  if (hasLoom) {
    return apps;
  }
  const modifiedApps = [...apps];
  modifiedApps.unshift({
    productId: LOOM_PRODUCT_ID,
    name: 'Loom',
    description: 'Record and share videos instantly',
    logo: 'https://fd-assets.prod.atl-paas.net/image/logos/contrib/loom/icons/purple.svg',
    journey: Journeys.DECIDE,
    reasons: ['the size of your team', 'your existing Atlassian products']
  });
  return modifiedApps.slice(0, 3);
}